/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/styles/sections/goal-product.scss":
/*!***********************************************!*\
  !*** ./src/styles/sections/goal-product.scss ***!
  \***********************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

eval("{__webpack_require__.r(__webpack_exports__);\n// extracted by mini-css-extract-plugin\n\n\n//# sourceURL=webpack://project_name/./src/styles/sections/goal-product.scss?\n}");

/***/ }),

/***/ "./src/scripts/sections/goal-product.js":
/*!**********************************************!*\
  !*** ./src/scripts/sections/goal-product.js ***!
  \**********************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

eval("{__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _styles_sections_goal_product_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../styles/sections/goal-product.scss */ \"./src/styles/sections/goal-product.scss\");\n\nconst SELECTORS = {\n  popupTrigger: '.js-goal-popup-trigger',\n  popup: '.js-goal-popup',\n  popupContainer: '.js-goal-popup-container',\n  popupClose: '.js-goal-popup-close'\n};\nconst initPopup = () => {\n  const $popup = document.querySelector(SELECTORS.popup);\n  if (!$popup) return;\n  const $trigger = document.querySelector(SELECTORS.popupTrigger);\n  if (!$trigger) return;\n  const $body = document.body;\n  $trigger.addEventListener('click', () => {\n    $body.classList.add('popup_open');\n  });\n  $popup.addEventListener('click', ({\n    target\n  }) => {\n    const $close = target.closest(SELECTORS.popupClose);\n    const isOverlay = target === $popup;\n    if ($close || isOverlay) {\n      $body.classList.remove('popup_open');\n    }\n  });\n};\nconst personalizationHandler = () => {\n  const $inputType = document.getElementById('personalization-type');\n  const $inputText = document.getElementById('personalization-text');\n  if (!$inputType || !$inputText) return;\n  const $personalizationTypes = document.querySelectorAll('[data-personalization-type]');\n  const $personalizationText = document.querySelector('[data-personalization-text]');\n  const $trigger = document.querySelector(SELECTORS.popupTrigger);\n  if (!$trigger) return;\n  if ($personalizationTypes.length) {\n    $personalizationTypes.forEach($personalizationType => {\n      if ($personalizationType.checked) {\n        $inputType.value = $personalizationType.value;\n      }\n      $personalizationType.addEventListener('click', () => {\n        $inputType.value = $personalizationType.value;\n      });\n    });\n  }\n  if ($personalizationText) {\n    $personalizationText.addEventListener('input', () => {\n      $inputText.value = $personalizationText.value;\n      if ($personalizationText.value !== '') {\n        $trigger.classList.add('active');\n      } else {\n        $trigger.classList.remove('active');\n      }\n    });\n  }\n};\ndocument.addEventListener('DOMContentLoaded', () => {\n  personalizationHandler();\n  initPopup();\n});\n\n//# sourceURL=webpack://project_name/./src/scripts/sections/goal-product.js?\n}");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		if (!(moduleId in __webpack_modules__)) {
/******/ 			delete __webpack_module_cache__[moduleId];
/******/ 			var e = new Error("Cannot find module '" + moduleId + "'");
/******/ 			e.code = 'MODULE_NOT_FOUND';
/******/ 			throw e;
/******/ 		}
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	var __webpack_exports__ = __webpack_require__("./src/scripts/sections/goal-product.js");
/******/ 	
/******/ })()
;